import { dashboardApiClient } from "./DashboardApiClient.js";

export async function listProductionDeploymentBuilds({
  client = dashboardApiClient,
  projectKey,
  availability = "actionable",
  page = 1,
  perPage = 100,
  signal
}) {
  return client.getJson(
    `projects/${projectKey}/application/production-builds`,
    { availability, page, per_page: perPage },
    true,
    signal
  );
}

export async function activateProductionDeploymentBuild({ client = dashboardApiClient, projectKey, buildId, idempotencyKey, signal }) {
  return client.postJson(
    `projects/${projectKey}/application/production-builds/${buildId}/activate`,
    {},
    true,
    { headers: { "Idempotency-Key": idempotencyKey }, signal }
  );
}

export async function deleteProductionDeploymentBuild({ client = dashboardApiClient, projectKey, buildId }) {
  return client.deleteJson(`projects/${projectKey}/application/production-builds/${buildId}`);
}
